import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {QuoteRequestService} from "./quote-request.service";

export default angular.module('slViz.quoteRequestModule', [
    angularUiBootstrap
])
    .service('QuoteRequestService', QuoteRequestService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/quote-request/index.js